<template>
  <div :class="containerClass" @click="onClick">
    <stat-tile :value="value"
               class="h-100 rounded-circle"
               :class="cssClass"
               :bg-color="bgColor"
               :color="color"
    >
      <div class="mx-auto align-self-center text-center">
        <b-row v-if="icon">
          <b-col class="pb-1 label">
            <slot name="icon"><custom-icon :icon="icon" :css-class="iconClass" /></slot>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="value">{{ value }}</b-col>
        </b-row>
        <b-row>
          <b-col class="label" :class="labelClass">{{ label }}</b-col>
        </b-row>
      </div>
    </stat-tile>
  </div>

</template>

<script>
import StatTile from '@/components/Dashboard/StatTile';
import CustomIcon from '@/components/Custom/CustomIcon';
import StatMixin from '@/components/Dashboard/StatMixin';

export default {
  name: 'StatCircle',
  components: {
    StatTile,
    CustomIcon,
  },
  mixins: [StatMixin],
  props: {
    iconClass: {
      type: String,
    },
    size: {
      type: String,
      default: 'medium',
    },
    labelClass: {
      type: String,
    },
  },
  computed: {
    containerClass() {
      let cssClass = 'circle-container ' + this.size;

      if (this.clickable || this.to) {
        cssClass = cssClass + ' cursor-pointer';
      }
      return cssClass;
    },
    styleCss() {
      let style = '';
      if (this.color) {
        style = 'color: ' + this.color + ';';
      }

      if (this.bgColor) {
        style = style + 'background: ' + this.bgColor + ';';
      }

      return style;
    },
  },
};
</script>

<style scoped>
  .circle-container {
    width: 6em; height: 6em;
  }
  .circle {
    width: 5em; height: 5em;
  }
  .circle-container .label {
    line-height: 10px;
  }
</style>
